export const STATUS_STOPPED = 'Stopped';
export const STATUS_CHECK_WAITING = 'Check waiting';
export const STATUS_CHECKING = 'Checking';
export const STATUS_DOWNLOAD_WAITING = 'Download waiting';
export const STATUS_DOWNLOADING = 'Downloading';
export const STATUS_SEED_WAITING = 'Seed waiting';
export const STATUS_SEEDING = 'Seeding';
export const STATUSES = [
  STATUS_STOPPED,
  STATUS_CHECK_WAITING,
  STATUS_CHECKING,
  STATUS_DOWNLOAD_WAITING,
  STATUS_DOWNLOADING,
  STATUS_SEED_WAITING,
  STATUS_SEEDING,
];
